import type { Auction, LimitedAuction } from '@b-stock/auction-api-client'

import getIsWithinBuyNowWindow from './getIsWithinBuyNowWindow'

const getCurrentPrice = (auction: Auction | LimitedAuction) => {
  // If we're in the buy now window and buy now is enabled with a price, return the buy now price
  if (getIsWithinBuyNowWindow(auction) && auction.buyNow?.price) {
    return auction.buyNow.price
  }

  // If there are bids (winningBidAmount > 0), return the winning bid amount
  if (auction.winningBidAmount && auction.winningBidAmount > 0) {
    return auction.winningBidAmount
  }

  // If no bids, return the start price (or 0 if null)
  return auction.startPrice || 0
}

export default getCurrentPrice
